import click from '@mailobj-browser/front/js/events/types/click.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import {
  tapUp
} from '@mailobj-browser/front/js/events/listeners/builtins/tap.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import stopImmediatePropagation
  from '@mailobj-browser/front/js/events/hooks/stopImmediatePropagation.js'
import capture from '@mailobj-browser/front/js/events/options/capture.js'
import once from '@mailobj-browser/front/js/events/options/once.js'
import keyUp from '@mailobj-browser/front/js/events/types/keyUp.js'
import * as hotkey from '../../hotkey/hotkey.js'
import { close, open } from '../menus/menu.js'
import * as utilities from '../../styles.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const menus = new WeakMap()
const templates = new WeakMap()

const onTapUp = object(tapUp, {
  hooks: array([
    stopImmediatePropagation
  ]),
  capture,
  passive,
  task: async (button) => {
    onKeyUp.forget(button)
    
    if (menus.has(button)) {
      close()

      return
    }

    const { ownerDocument } = button
    const container = one(`.${utilities.elements.aside_lightboxes}`, ownerDocument)
    const menu = await open(templates.get(button), container, button)

    hotkey.disable(menu)
    menus.set(button, menu)

    queueMicrotask(async () => {
      await removed(menu)
      menus.delete(button)
    })
  }
})

const onClick = object(listener, {
  type: click,
  passive,
  task: (button) => {
    onKeyUp.listen(button)
  }
})

const onKeyUp = object(listener, {
  type: keyUp,
  once,
  passive,
  task: (button, { key }) => {
    if (key === 'Enter') {
      onTapUp.trigger(button)
    }
  }
})

export default template => {
  const { parentNode } = template

  templates.set(parentNode, template)
  onClick.listen(parentNode)
  onTapUp.listen(parentNode)
}
